interface Clinic
{
    id: string;
    name: string;
    location: string;
}

interface Speciality
{
    id: string;
    name: string;
}

export class ClinicianSpecialty
{
    public readonly clinic: Clinic;

    public readonly specialty: Speciality;

    public readonly subSpecialty: Speciality;

    public readonly invitationAccepted?: boolean;

    public readonly appointmentsDuration?: string;

    public readonly intervalBetweenAppointments?: string;

    public constructor(
        clinic: Clinic,
        specialty: Speciality,
        subSpecialty: Speciality,
        invitationAccepted?: boolean,
        appointmentsDuration?: string,
        intervalBetweenAppointments?: string
    )
    {
        this.clinic = clinic;
        this.specialty = specialty;
        this.subSpecialty = subSpecialty;
        this.invitationAccepted = invitationAccepted;
        this.appointmentsDuration = appointmentsDuration;
        this.intervalBetweenAppointments = intervalBetweenAppointments;
    }

    public static fromJSON(clinician): ClinicianSpecialty
    {
        return new ClinicianSpecialty(
            clinician.clinic,
            clinician.speciality,
            clinician.subSpeciality,
            clinician.invitationAccepted,
            clinician.appointmentsDuration,
            clinician.intervalBetweenAppointments
        );
    }
}
